import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ActivateComponent } from './activate.component';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('registration.activate', {
            url: '/activate/:token',
            ncyBreadcrumb: {
                label: 'Attivazione Account',
                parent: 'registration'
            },
            params: {
                token: ''
            },
            data: {
                authorisationLevel: 0,
                pageTitle: 'Attivazione Account'
            },
            'views': {
                'multiContentRegistration': {
                    template: '<activate flex="100"></activate>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ActivateModule: string = ng
    .module('archiSmall.registration.activate', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('activate', ActivateComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/activate/activate.module.ts